import getTag from './_getTag.js';
import isObjectLike from './isObjectLike.js';

/** `Object#toString` result references. */
var setTag = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike(value) && getTag(value) == setTag;
}

export default baseIsSet;



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/_baseIsSet.js
// module id = 2303
// module chunks = 0